import { requestOfGet, requestOfPost } from '../utils/http'
const baseUrl = 'wechath5/zh-cn/v1/'
// 扫码取号扫描后信息
export function getScanTakeNumber(param) {
  return requestOfPost(`${baseUrl}key/apply`,param)
}
// 获取手牌二维码、消费金额等信息
export function getScanTakeNumberInfo(param) {
  return requestOfGet(`${baseUrl}key/bindinginfo`,param)
}
export function getScanCardBinderInfo(param) {
  return requestOfPost(`${baseUrl}key/binder`,param)
}
export function getCardInfo(param) { //获取手牌开牌信息
	return requestOfGet(`${baseUrl}checkin`,param)
}
export function getCardConsumeList(data) { //获取手牌消费信息
	return requestOfPost(`${baseUrl}checkin/selfcheckout`,data)
}
export function getCardConsumeMoney(data) { //获取手牌消费金额
	return requestOfPost(`${baseUrl}checkin/selfcheckout/settle`,data)
}

export function waitercall(data) { //呼叫服务员
	return requestOfPost(`${baseUrl}meal/waitercall`,data)
}

